// extracted by mini-css-extract-plugin
export var dateBox = "post-meta-module--date-box--Y6yN5";